import { api } from '../lib/api'

export const followService = {
  async follow(userId) {
    await api.post(`/v1/follow/${userId}`, {})
  },
  async unfollow(userId) {
    await api.delete(`/v1/follow/${userId}`)
  }
}
